import { motion } from "framer-motion";
import { Compass, Search, Megaphone, MonitorSmartphone, Sparkles } from "lucide-react";

export const ICONS = {
  "digital-marketing-strategy": Compass,
  "google-ads-management": Search,
  "meta-ads-management": Megaphone,
  "web-development": MonitorSmartphone,
};
export const iconFor = (id) => ICONS[id] || Sparkles;

const HIDDEN = { opacity: 0, y: 24 };
const SHOWN = { opacity: 1, y: 0 };
const VIEWPORT = { once: true, margin: "-60px" };
const EASE = [0.22, 1, 0.36, 1];
const transitions = {};
const transitionFor = (delay) => (transitions[delay] ||= { duration: 0.6, delay, ease: EASE });

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div className={className} initial={HIDDEN} whileInView={SHOWN} viewport={VIEWPORT} transition={transitionFor(delay)}>
    {children}
  </motion.div>
);

export const PageHeader = ({ overline, title, children, testid }) => (
  <section className="relative overflow-hidden grid-lines border-b" data-testid={testid}>
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-36 pb-16 sm:pb-24">
      <Reveal>
        <p className="overline mb-5">{overline}</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] max-w-4xl text-slate-900">{title}</h1>
        {children && <div className="mt-6 text-base sm:text-lg text-slate-600 max-w-2xl leading-relaxed">{children}</div>}
      </Reveal>
    </div>
  </section>
);
